module.exports = __webpack_public_path__ + "img/cv.96e28345.svg";